import apiRequest from "../../helpers/apiRequest";

export default async (params) => {
  return await apiRequest({
    method: "post",
    url: `accounts/custom-confirm-password-reset/`,
    data: params,
  });
};
